import React from "react";

const OpenLibraryMcq = ({ sQuestion, questionNumber, filter }) => {
  return (
    <>
      <div className="mt-3 library_mcq_box">
        <span className="library_mcq_question ">
          Q{questionNumber + 1}. {sQuestion?.title}
        </span>
        {<div style={{ fontSize: "15px" }}>{sQuestion?.question?.domain?.name || '-'} | {sQuestion?.question?.skill?.name || '-'} | {sQuestion?.question?.type?.name || '-'} | {sQuestion?.question?.difficulty_level?.name || '-'} |
          {" " + sQuestion?.question?.book?.name || '-'} : {sQuestion?.question?.chapter?.chapterName || '-'}
        </div>}
        <div className="mt-2">
          <ul>
            {sQuestion?.options?.length > 0 &&
              sQuestion?.options?.map((option, index) => (
                <div key={index} className="library_mcq_option">{option?.key + " "} - {option?.value}</div>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default OpenLibraryMcq;
